import React from 'react';
import { useNavigate } from 'react-router-dom'; // Reemplazamos useHistory por useNavigate
import { motion } from 'framer-motion';
import { Anchor, Calendar, DollarSign, FileText, Users, ChevronRight, TicketCheck  } from 'lucide-react';

// Componente de tarjeta individual
const HistoricoCard = ({ icon: Icon, title, description, link, color }) => {
  const navigate = useNavigate(); // Hook de navegación

  return (
    <div 
      className="bg-opacity-10 backdrop-filter backdrop-blur-lg p-6 rounded-lg shadow-lg cursor-pointer transition-all duration-300 hover:scale-105"
      style={{ backgroundColor: `rgba(${color}, 0.1)` }}
      onClick={() => navigate(link)} // Navegación al hacer clic
    >
      <div className="flex items-center mb-4">
        <Icon className="w-8 h-8 mr-3" style={{ color: `rgb(${color})` }} />
        <h3 className="text-xl font-semibold" style={{ color: `rgb(${color})` }}>
          {title}
        </h3>
      </div>
      <p className="text-gray-300 mb-4">{description}</p>
      <div className="flex items-center" style={{ color: `rgb(${color})` }}>
        <span className="mr-2">Ver detalles</span>
        <ChevronRight className="w-4 h-4" />
      </div>
    </div>
  );
};

// Componente principal con las tarjetas
const HistoricoComponents = () => {
  const secciones = [
    {
      icon: Anchor,
      title: "Movimientos de Embarcaciones",
      description: "Historial de entradas y salidas de embarcaciones en la marina.",
      link: "/historico-movimientos",
      color: "46, 204, 113" // Verde Esmeralda
    },
    {
      icon: DollarSign,
      title: "Registros de Ingresos",
      description: "Historial de ingresos diarios, incluyendo ventas de entradas y servicios.",
      link: "/historico-registros", // Actualiza este enlace
      color: "241, 196, 15" // Amarillo Dorado
    },
    {
      icon: TicketCheck,
      title: "Ventas por Usuario",
      description: "Historial de ventas realizadas por cada usuario.",
      link: "/historico-ventas-por-usuario",
      color: "241, 196, 15" // Amarillo Dorado
    },
    {
      icon: Users,
      title: "Registro de Clientes",
      description: "Historial de registros y actividades de clientes en la marina.",
      link: "/historico-clientes",
      color: "52, 152, 219" // Azul Claro
    },
    {
      icon: Calendar,
      title: "Reservas",
      description: "Historial de reservas de amarres y servicios adicionales.",
      link: "/historico-reservas",
      color: "27, 79, 114" // Azul Oscuro
    },
    {
      icon: FileText,
      title: "Informes Generales",
      description: "Acceso a informes históricos y análisis de datos de la marina.",
      link: "/informes-generales",
      color: "250, 250, 250" // Blanco Puro
    }
  ];

  return (
    <div className="min-h-screen p-4 md:p-8" style={{ background: 'linear-gradient(to bottom right, #1B4F72, #3498DB)' }}>
      <motion.header 
        className="mb-12 text-center"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#F1C40F' }}>
          Históricos
        </h1>
        <p className="text-xl" style={{ color: '#BDC3C7' }}>
          Accede a los registros históricos del camping
        </p>
      </motion.header>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {secciones.map((seccion, index) => (
          <motion.div
            key={seccion.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <HistoricoCard {...seccion} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default HistoricoComponents;
